import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df2e76e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-faq",
  class: "page-faq"
}
const _hoisted_2 = { class: "page-faq-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, " 원더플 캠페인 FAQ ", -1))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1))
const _hoisted_6 = { class: "collapse-title" }
const _hoisted_7 = { class: "indicator" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "faq-content" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const tabs = [
    {
      name: '지원하기',
      faqs: [
        {
          title: '지원 신청이 완료되었는지 어떻게 확인할 수 있나요?',
          content: [
            {
              text: '신청이 완료되면 프로필 정보에 등록하신 핸드폰 번호로 카카오톡 알림 메시지가 발송되며, 이후 마이페이지에서 확인 가능합니다.'
            }
          ]
        },
        {
          title: '여러 번 참여할 수 있나요?',
          content: [
            {
              text: '계정 당 1회만 참여 가능합니다. 이전 회차에서 탈락하셨던 분들은 다음 회차에 지원하실 수 있습니다.'
            },
          ]
        },
        {
          title: `챌린지 유형을 바꾸고 싶어요!
4박스 챌린지에 지원했는데 2박스 챌린지로 바꿀 수 있나요?`,
          content: [
            {
              text: '챌린지 유형은 신청 후 변경이 불가합니다. 또한 2박스 챌린지 신청자가 4박스 챌린지에 중복 신청할 수 없습니다. (계정 당 1개 유형만 신청 가능) 보다 많은 원더플 피플이 캠페인을 경험할 수 있도록 양해 부탁드립니다.'
            },
          ]
        },
      ]
    },
    {
      name: '수거 신청',
      faqs: [
        {
          title: '주소 변경 등의 이유로 개인 정보 변경을 희망합니다.',
          content: [
            {
              text: '마이 페이지에서 수정 가능합니다. 등록된 주소지로 제로 웨이스트 박스 발송 / 수거 / 리워드 발송이 진행되므로 정확한 주소 입력을 부탁드립니다. '
            },
          ]
        },
        {
          title: '제로 웨이스트 박스 배송비는 본인 부담인가요?',
          content: [
            {
              text: '원더플 캠페인은 참여자들의 비용 부담 없이 무료로 진행됩니다. 원더플 피플은 올바른 분리배출법에 따라 투명 음료 페트병을 모아주면 돼요.'
            }
          ]
        },
        {
          title: '캠페인 기간 내 박스를 채우지 못했어요. 어떻게 해야 하나요?',
          content: [
            {
              text: '수거 신청은 사전에 공지된 기간에만 가능하며, 약속된 기간 내 제로 웨이스트 박스가 수거되지 않으면 리워드가 제공되지 않습니다. 기간 내 완수하지 못한 참여자 분들께서는 환경을 위해 제로 웨이스트 박스와 페트병을 자체적으로 분리배출해 주시기 바랍니다. '
            }
          ]
        },
      ]
    },
    {
      name: '리워드/배송',
      faqs: [
        {
          title: '리워드 배송 일정이 궁금해요.',
          content: [
            {
              text: `올바른 방법으로 투명 음료 페트병을 모아 보내 주신 분들에 한하여 순차적으로 리워드를 배송할 예정입니다.
제로 웨이스트 박스는 테라사이클에서 하나하나 검수하는 만큼 수거에서 검수까지 시간이 소요됩니다.
캠페인 운영 과정에서 리워드 배송이 지연될 수 있는 점 양해 부탁드립니다.`
            },
          ]
        },
        {
          title: '리워드를 별도 구매할 수 있나요?',
          content: [
            {
              text: '리워드는 캠페인에 참여해 주신 원더플 피플에게 감사의 의미로 제공될 예정입니다. 별도 구매는 불가합니다.'
            },
          ]
        },
      ]
    }
  ];


return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_AppTabs, { class: "faq-tabs" }, {
        trigger: _withCtx((scope) => [
          _createElementVNode("div", {
            class: _normalizeClass(["faq-tab-item", { active: scope.active }])
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(scope.label), 1)
          ], 2)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_AppTab, {
              key: tab.name,
              label: tab.name
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.faqs, (faq, index) => {
                  return (_openBlock(), _createBlock(_component_AppCollapse, {
                    key: index,
                    class: "faq-collapse"
                  }, {
                    trigger: _withCtx(({ visible }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                      }, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, _toDisplayString(faq.title), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: require('./btn-arrow-down.png')
                          }, null, 8, _hoisted_8)
                        ])
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.content, (item, contentIndex) => {
                          return (_openBlock(), _createElementBlock("div", { key: contentIndex }, _toDisplayString(item.text), 1))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"])
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})